/* eslint-disable react-refresh/only-export-components */
/**
 * Billing Context for Falcon
 *
 * This is a wrapper around @roselabs-io/saas-shell BillingProvider that:
 * - Automatically extracts teamId from URL params (useParams)
 * - Maintains backward compatibility with existing imports
 *
 * Usage remains the same:
 * - Wrap routes with <BillingProvider>
 * - Use useBilling() hook in components
 */

import type { ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { BillingProvider as SaasShellBillingProvider, useBilling } from '../lib/billing'

// Re-export types for backward compatibility
export type {
  BillingStatus,
  BillingRestriction,
  BillingContextType,
  PlanResponse,
  SubscriptionResponse,
  UsageResponse,
} from '../lib/billing'

// Re-export the hook
export { useBilling }

interface BillingProviderProps {
  children: ReactNode
}

/**
 * BillingProvider that automatically uses teamId from URL params
 */
export function BillingProvider({ children }: BillingProviderProps) {
  const { teamId } = useParams<{ teamId: string }>()

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SaasShellBillingProvider getTeamId={() => teamId ?? null} children={children as any} />
  )
}
